var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"11","height":"16","viewBox":"0 0 11 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2.00005 14.0313L8.04272 7.98858L2.00005 1.9459","stroke":"#0A8EFF","stroke-width":"3.39614"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }